import React, {Suspense} from 'react'
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom'
import LearnersDashboardRoutes from './LearnersDashboardRoutes'
import AdminDashboardRoutes from './AdminDashboardRoutes'
import CourseLayout from "../layouts/CourseLayout";
import FullStack from "../components/Courses/FullStack";
import DataScience from "../components/Courses/DataScience";

const Register = React.lazy(() => import('../pages/register/Register'))
const SuccessfulRegistered = React.lazy(() => import('../pages/success/SuccessfulRegistered'))
const Verified = React.lazy(() => import('../pages/success/Verified'))
const ConfirmUser = React.lazy(() => import('../pages/register/ConfirmUser'))
const Login = React.lazy(() => import('../pages/Login'))
const LearnersLayoutWithContext = React.lazy(() => import('../layouts/LeanersDashboardLayout'))
const AdminLayoutWithContext = React.lazy(() => import('../layouts/AdminDashboardLayout'))
const LearnersRegistration = React.lazy(() => import('../pages/register/LearnersRegistration'))
const Selection = React.lazy(() => import('../pages/register/Selection'))
const LoggedOutRoute = React.lazy(() => import('./LoggedOutRoute'))
const PrivateRoute = React.lazy(() => import('./PrivateRoute'))
const LandingPage = React.lazy(() => import('../pages/LandingPage'))
const AboutUs = React.lazy(() => import('../pages/About'))
const ForgotPassword = React.lazy(() => import('../pages/ForgotPassword'))
const ResetPassword = React.lazy(() => import('../pages/ResetPassword'))
const ResetSent = React.lazy(() => import('../pages/success/ResetSent'))
const ResetPasswordSuccessful = React.lazy(() => import('../pages/success/ResetPasswordSuccessful'))

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const AppRouter = () => {
  return (
    <Router>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/register" name="Register Page" element={<Register/>}/>
          <Route exact path="/" name="Landing Page" element={<LandingPage/>}/>
          <Route exact path="/about-us" name="About Us" element={<AboutUs/>}/>
          <Route
            exact
            path="/register-success"
            name="Register Success Page"
            element={<SuccessfulRegistered/>}
          />
          <Route
            exact
            path="/forgot-password"
            name="Forgot Password Page"
            element={<ForgotPassword/>}
          />
          <Route
            exact
            path="/forgot-password-success"
            name="Reset sent success Page"
            element={<ResetSent/>}
          />
          <Route
            exact
            path="/reset-password-success"
            name="Reset sent success Page"
            element={<ResetPasswordSuccessful/>}
          />
          <Route
            exact
            path="/verify/:id/:uuid"
            name="Verification Page"
            element={<ConfirmUser/>}
          />
          <Route
            exact
            path="/reset-password/:id/:uuid"
            name="Reset Password Page"
            element={<ResetPassword/>}
          />
          <Route
            exact
            path="/verified-success"
            name="Verified Success Page"
            element={<Verified/>}
          />
          <Route exact path="/registration" element={<PrivateRoute/>}>
            <Route exact path="/registration" element={<Selection/>}/>
          </Route>
          <Route exact path="/learners-registration" element={<PrivateRoute/>}>
            <Route exact path="/learners-registration" element={<LearnersRegistration/>}/>
          </Route>
          <Route path="/learner" element={<PrivateRoute/>}>
            <Route path="/learner" element={<LearnersLayoutWithContext/>}>
              {LearnersDashboardRoutes.map((route, idx) => {
                return (
                  route.element && (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      element={<route.element/>}
                    />
                  )
                )
              })}
              <Route path="" element={<Navigate to="dashboard" replace/>}/>
            </Route>
          </Route>
          <Route path="/admin" element={<PrivateRoute/>}>
            <Route path="/admin" element={<AdminLayoutWithContext/>}>
              {AdminDashboardRoutes.map((route, idx) => {
                return (
                  route.element && (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      element={<route.element/>}
                    />
                  )
                )
              })}
              <Route path="" element={<Navigate to="dashboard" replace/>}/>
            </Route>
          </Route>
          <Route exact path="/login" element={<LoggedOutRoute/>}>
            <Route exact path="/login" element={<Login/>}/>
          </Route>
          <Route path="/course" element={<CourseLayout/>}>
            <Route path="/course/full-stack-development" element={<FullStack/>}/>
            <Route path="/course/data-science" element={<DataScience/>}/>
          </Route>
        </Routes>
      </Suspense>
    </Router>
  )
}

export default AppRouter
